import React from 'react'
import error from "../../src/assets/images/No-File-small.png";


const NotFound = () => {
  return (
    <>
      <div className="pt-5 pb-5">
         <div className="mt-6 error-image-cont error-cont m-auto d-flex justify-content-center">                  
                <img src={error} alt="404 Not Found" width={300} />
           </div>
       </div>
      </>
  )
}

export default NotFound